import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'sg-endgame-dialog',
  templateUrl: './endgame-dialog.component.html',
  styleUrls: ['./endgame-dialog.component.scss']
})
export class EndgameDialogComponent {

  @Input() feedbackText = false;
  @Output() endgameDialogChange = new EventEmitter();

  // [routerLink]="['']";
  // this.router.navigate(['']);

}
